<template>
  <div class="updateLog">
    <div class="dialogContent">
      <img class="preRefresh" src="~@/assets/images/Home/update.png">
      <div class="updateTitle">
        旺店通跨境ERP
        <span style="color:#3b6dff">{{ updateVersion }}</span>
        更新内容
      </div>
      <div class="dateArea">{{ refreshTime }}</div>
      <div class="listArea">
        <div v-for="(item,index) in updateList" :key="index">
          <div class="titleItem">{{ item.title }}</div>
          <div v-for="(it,i) in item.content" :key="i" class="listItem">{{ it }}</div></div>
      </div>
      <div class="updateButton">
        <el-checkbox v-model="noNotice" style="margin-right: 16px">不再提示</el-checkbox>
        <el-button type="default" style="margin-right: 16px" @click="linkToWiki">更新详情</el-button>
        <el-button type="primary" @click="handleClickKnow">我知道了</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    mainData: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  data() {
    return {
      noNotice: false,
      refreshTime: '', // 更新时间
      updateVersion: '', // 更新版本
      updateList: [], // 更新内容
    }
  },
  created() {
    this.acquireNoticeInfo()
  },
  methods: {
    async handleClickKnow() {
      if (this.noNotice) {
        await this.$request(this.$api.login.closeNotice)
      }
      this.$emit('cancel')
      this.$cookie.set('noticeVisibleBi', '0', { domain: '.' + document.domain.split('.').slice(-2).join('.') })
    },
    linkToWiki() {
      window.open('http://wiki.huice.com/kj/open/notice?path=%E5%8D%87%E7%BA%A7%E6%97%A5%E5%BF%97')
    },
    async acquireNoticeInfo() {
      const { noticeContent, updateVersion, noticeTime } = this.mainData
      this.refreshTime = noticeTime
      this.updateVersion = updateVersion
      this.updateList = noticeContent
    }
  }
}
</script>

<style lang="scss" scoped>
.updateLog{
  // background: #fff;
  // border-radius: 4px;
  .dialogContent{
    width: 100%;
    height: 100%;
    overflow: auto;
    background: linear-gradient(180deg, rgba(59, 109, 255, 0.32) 0%, rgba(104, 143, 255, 0.12) 27%, rgba(196, 239, 255, 0) 100%);
    padding: 32px;
    .preRefresh{
      position: absolute;
      top:32px;
      right: 32px;
      width:136px;
      height:136px;
      z-index:999;
    }
    .updateTitle{
      max-width: 63%;
      font-size: 22px;
      // font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #313233;
      line-height: 36px;
    }
    .dateArea{
      font-size:20px;
      margin-top:10px;
      height: 40px;
      line-height: 40px;
      width: fit-content;
      border-bottom: 2px solid rgba(59,109,255, .4);
    }
    .listArea{
      //margin-top: 32px;
      margin-top:4px;
      height: 230px;
      overflow: auto;
      .listItem{
        margin-top: 12px;
        font-size: 14px;
        // font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #313233;
      }
    }
    .updateButton{
      //margin-top: 48px;
      margin-top:32px;
      font-size:0;
      float: right;
      ::v-deep .el-button--primary{
        background: #3b6dff;
        margin-left:0;
        padding:8px 20px;
        border-radius:4px;
        font-size:14px;
        // font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600
      }
      ::v-deep .el-button--default{
        border-color: #3b6dff;
        color: #3b6dff;
        padding:8px 24px;
        border-radius:4px;
        font-size:14px;
        // font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
      }
    }
  }
}
.titleItem{
  font-size: 16px;
  // font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #3b6dff;
  margin-top: 16px;
  height:32px;
  margin-bottom: -8px;
}
.link-mask{
  display:flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  width: .38em;
  height: .38em;
  background: #EFF6FE;
  border-radius: 0.0475em;
  transform:scale(1.4);
  margin-top:.081em;
  &:hover{
    background: #DDEDFF;
  }
}
</style>
